import { getCookie, setCookie } from './Cookies';
import { gsap } from 'gsap';

export class WbHeaderNotification {
  constructor() {
    this.init();
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;

    const links = document.querySelectorAll('.wb-alert__close');
    links.forEach((link) => _this.addAlertListener(link));
  }

  addAlertListener(link) {
    const _this = this;
    const data = link.dataset.dismiss;

    link.addEventListener('click', _this.closeAlert.bind(_this));

    const cookie = getCookie(data + 'Close');
    const alert = link.closest(data);
    if (cookie && cookie != 0 && window.getComputedStyle(alert).display !== 'none') alert._hide(0);
  }

  closeAlert(e) {
    const target = e.currentTarget;
    const data = target.dataset.dismiss;
    const alert = target.closest(data);

    alert.classList.add('wb-alert--hidden');
    setCookie(data + 'Close', 1, 60 * 24);
    gsap.to(WbMasthead.ele, {
      marginTop: 0,
      duration: 0.15,
      onComplete: () => {
        alert._hide(0);
      },
    });
  }
}
